import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: resolve => require(['../components/Home.vue'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/aboutus',
      name: 'Aboutus',
      component: resolve => require(['../components/Aboutus.vue'], resolve),
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/productservice',
      name: 'ProductService',
      component: resolve => require(['../components/ProductService.vue'], resolve),
      meta: {
        title: '产品服务'
      }
    },
    {
      path: '/productservicedetail',
      name: 'ProductServiceDetail',
      component: resolve => require(['../components/ProductServiceDetail.vue'], resolve),
      meta: {
        title: '产品服务详情'
      }
    },
    {
      path: '/information',
      name: 'Information',
      component: resolve => require(['../components/Information.vue'], resolve),
      meta: {
        title: '资讯信息'
      }
    },
    {
      path: '/informationdetail',
      name: 'informationDetail',
      component: resolve => require(['../components/InformationDetail.vue'], resolve),
      meta: {
        title: '资讯信息详情'
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: resolve => require(['../components/Recruit.vue'], resolve),
      meta: {
        title: '人才招聘'
      }
    },
    {
      path: '/contactus',
      name: 'Contactus',
      component: resolve => require(['../components/Contactus.vue'], resolve),
      meta: {
        title: '联系我们'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js